<style scoped>
	.plan-card .button[disabled]:hover,
	.plan-card .button.disabled:hover {
		cursor: not-allowed;
	}

	.plan-comparison {
		max-width: calc(50% - .5rem);
	    min-width: calc(50% - .5rem);
	    width: calc(50% - .5rem);
	}

	.plan-comparison .button.disabled {
		/* color: #333; */
		/* opacity: 1; */
	}
	.plan-comparison .button.disabled:hover {
		cursor: default;
	}
	.plan-cards {
		/* min-height: 389px; */
	}
	.plan-card {
		cursor: pointer;
		box-sizing: border-box;
		border-width: 2px;
		width: calc(25% - .75em);
	}
	.dark .plan-card {
		border-color: #333;
	}
	.plan-card:nth-child(5), .plan-card:nth-child(6), .plan-card:nth-child(7) {
		max-width: calc(25% - .75em);
		margin-top: 1em;
	}
	.plan-card:nth-child(5)  {
		margin-left: 0;
	}
	.plan-card.hidden + .plan-card,
	label[style*='display: none'] + .plan-card {
		margin-left: 0;
	}
	/* .plan-card:not(.strikethrough):not(.selected):hover {
		border-color: #bbb;
	}
	.plan-card:not(.strikethrough):not(.selected):hover i {
		color: #bbb;
	} */
	.strikethrough .badge {
		visibility: hidden;
	}
	.plan-card.strikethrough {
		cursor: not-allowed;
	}
	.plan-card.strikethrough i {
		display: none;
	}
	.plan-card > header > h1 {
		margin-top: 0;
	}
	.plan-card > header {
		margin-bottom: 1.5em;
	}
	.plan-card i {
		font-size: 1.2em;
		color: #ddd;
	}
	.dark .plan-card i {
		color: #333;
	}
	.plan-card.review-change i {
		display: none;
	}
	.plan-card.plan-card-primary {
		border-width: 2px;
	}
	.plan-card.selected {
		border-color: #2E88D6;
	}

	.review-change.plan-card {
		border-color: #DDD;
	}

	.dark .review-change.plan-card {
		border-color: #333;
	}

	.plan-card.selected i {
		color: #2E88D6;
	}

	.review-change .plan-card.plan-card-primary.selected {
		border-color: #DDD;
	}

	.plan-card.selected i {
		display: block;
	}
	.plan-features {
		text-align: left;
		margin: 0 0 3rem;
	}
	.plan-features li i:not(.success):not(.error),
	.plan-card.selected i {
		color: #2E88D6;
	}
	.plan-comparison .current-plan .plan-features li i:not(.success):not(.error){
		color: #777;
	}
	.plan-features li .bullet-margin {
		width: 1.5rem;
		text-align: left;
	}
	.plan-features li {
		line-height: 1.4rem;
		margin-bottom: .5rem;
	}
	.strikethrough {
		color: #999;
	}
	.strikethrough.selected i{
		display: none;
	}
	.plan-features li.strikethrough i.fas {
		color: #ddd;
	}
	.dark .plan-features li.strikethrough i.fas {
		color: #555;
	}
	.plan-features > .column {
		width: 50%;
	}
	footer.choose-plan.row {
		margin-left: auto;
		width: 50%;
	}
	footer.choose-plan.row button {
		margin-left: auto;
		width: calc(50% - .5em);
	}


	.review-change .button.success.active + .button.success.active {
		display: none;
	}
	.billing-options.row .button {
		width: 100%;
	}
	.plan-option:first-of-type {
		margin-top: auto;
	}
	.annual.badge {
		position: absolute;
		top: -.5rem;
		right: .5rem;
	}
	.plan-comparison .current-plan:not(.new-plan) .annual.badge {
		display: none;
	}
	.button {
		overflow: visible;
		text-align: center;
	}
	.button.active:before {
		content: '\f00c';
		font-family: 'Font Awesome 5 Free';
		font-weight: 900;
		position: absolute;
		left: 1rem;
	}
 	.button.new.active:before {
		color: #2E88D6;
	}
	.button.success.new.active:before {
		color: #fff;
	}

	h1.total {
		margin: 0;
	}
	h2 {
		line-height: 1.4em;
	}
	.half-width {
		max-width: calc(50% - .5rem);
		min-width: calc(50% - .5rem);
		width: calc(50% - .5rem);
	}
	.cost-summary {
		height: 86px;
		max-width: calc(50% - .5rem);
	    min-width: calc(50% - .5rem);
	    width: calc(50% - .5rem);
	}
	.change-summary {
		padding-right: 5rem;
		width: 50%;
	}
	.change-summary ul,
	.change-summary ul ul {
		list-style-type: none;
	}

	.payment-notice {
		margin: 0;
	}

	section {
		margin-bottom: 2rem;
	}

	footer.row button {
		width: 100%;
	}

	footer .payment-notice + footer {
		margin-top: 2rem;
	}

	.notice a {
		font-weight: bolder;
	}

	.popover-target-wrapper i.mouseover {
		color: #bbb !important;
	}

	.dark .popover-target-wrapper i.mouseover {
		color: #555 !important;
	}

	.space-between {
		justify-content: space-between;
	}

	.space-between .badge-success {
		font-size: 16px;
	}

	@media only screen and (max-width : 1120px) {
		.plan-cards {
			width: 100%;
			box-sizing: border-box;
			flex-wrap: wrap;
		}

		.change-summary {
			width: 100%;
			padding-right: 0;
		}

		/* .row.separated-extra > .plan-comparison {
			min-width: 100%;
			margin-left: 0;
		} */

		.review-change {
			flex-direction: column;
		}

		.plan-card {
		    box-sizing: border-box;
		}

		.change-plan-wrapper > header {
			background: white;
			position: sticky;
			top: 0;
			z-index: 2;
			padding: 1rem 0;
			box-sizing: border-box;
		}

		.dark .change-plan-wrapper > header {
			background: #1a1a1a;
		}
	}

	@media (min-width : 640px) and (max-width : 1120px) {
		.plan-card:not(.review-change) {
			min-width: calc(50% - .5rem);
			max-width: calc(50% - .5rem);
		    box-sizing: border-box;
			margin-left: 0;
		}

		.plan-card:nth-child(even) {
			margin-left: 1rem;
		}

		.plan-card:nth-child(odd) {
			margin-left: 0;
		}

		.plan-card:nth-child(n+3) {
			margin-top: 1rem;
		}
	}

	@media only screen and (max-width : 799px) {
		.plan-comparison footer.row {
			flex-direction: column;
		}
		.plan-comparison footer.row.separated-extra .flexible + .flexible {
			margin-top: 1em;
			margin-left: 0;
		}
	}

	@media only screen and (max-width : 639px) {
		.plan-features.row {
			flex-direction: column;
		}

		.plan-features > .column{
			width: 100%;
			margin-left: 0;
		}

		.change-plan-wrapper > header.row,
		.change-plan-wrapper > div.row {
			flex-direction: column;
		}

		.row.separated .flexible.cost-summary {
			min-width: 100%;
			margin-left: 0 !important;
		}

		.plan-comparison {
			min-width: 100%;
			margin-left: 0;
		}

		.row.separated-extra > * + .plan-comparison {
			margin-left: 0;
		}

		.plan-cards {
			flex-direction: column;
		}

		.plan-card {
			width: 100%;
		}

		.plan-card + .plan-card {
			margin-top: 1rem;
			margin-left: 0;
		}

		.review-change footer.row {
			flex-direction: column-reverse;
		}

		.review-change footer.row button + button {
			margin-left: 0;
			margin-bottom: 1rem;
		}

		footer.choose-plan.row button {
			width: 100%;
		}
	}

	@media only screen and (max-width : 415px) {
		.cost-summary h4 {
			margin-bottom: .25rem;
			white-space: nowrap;
		}
		.cost-summary h1 {
			margin-top: 1em;
		}
	}

	@media only screen and (min-width : 600px) and (max-width : 775px) {
		.cost-summary h4 {
			margin-bottom: .25rem;
			white-space: nowrap;
		}
		.cost-summary h1 {
			margin-top: 1em;
		}
	}

</style>


<template>
	<form class="column flexible detail-page content content-1100 scope" @submit.prevent="createSubscription">
		<header class="column">
			<div class="row centering separated">
				<button class="link" title="Go to Account Home" @click="leavePlan" type="button" name="button"><i class="fas fa-arrow-left"></i></button>
				<h1-placeholder :text="'TekScope Subscription'" v-if="subscriptionLoading"></h1-placeholder>
				<h1 class="gap" v-else>
					<span v-if="showOnboardingFlow">Setup your</span>
					<span v-else>Add</span>
					TekScope Subscription
				</h1>
			</div>
		</header>
		<div v-if="redirectReason">
			<p v-if="redirectReason === 'expired'" class="notice warn subscription-expired">
				Your subscription has expired. Select a new subscription below to continue using this account.
			</p>
		</div>

		<div class="column change-plan-wrapper">
			<header class="row rigid separated centering">
				<div v-if="subscriptionLoading" class="flexible row separated-extra baseline">
					<h2-placeholder :text="'Your Plan'"></h2-placeholder>
				</div>
				<div v-else class="flexible row separated-extra baseline">
					<h2 class="rigid" :class="{muted: newPlan}">1. Choose a Plan</h2>
					<h2 class="rigid" :class="{muted: !newPlan}">2. Review</h2>
				</div>
				<!-- free summary
				paid summary
				free trial summary  -->

				<div :class="{invisible:subscriptionLoading || !selectionId}" class="flexible card card-secondary row centering cost-summary">
					<div class="flexible" v-if="selectionId">
						<!-- is potential free trial -->
						<div class="row centering flexible" v-if="selection.hasTrial && useTrial">
							<div class="column separated flexible">
								<h4 class="flexible">
									Ends in {{TRIAL_DAYS}} Days
								</h4>
								<small class="gray-6 rigid">Won't auto-renew</small>
							</div>
							<h1 class="total rigid">
								<strong>Free</strong>
							</h1>
						</div>

						<!-- is potential paid plan -->
						<div class="row centering flexible" v-else-if="selection.id && selectionCost">
							<div class="column separated flexible">
								<h4 class="flexible">
									Due now
								</h4>
								<small class="rigid" :class="{'invisible':!paymentMethodLoaded}">
									<span class="row centering separated" v-if="account.paymentMethod">
										<toggle-switch tabindex="0" @change="onRenewalChange" v-model="subRenews" :disabled="submitting"></toggle-switch>
										<span class="rigid gray-6">Auto-renews</span>
									</span>
									<router-link v-else class="row rigid" to="/payments/method?returnPath=%2Fsubscriptions%2Fscope">Add a card to auto-renew</router-link>
								</small>
							</div>
							<div class="rigid column">
								<h1 class="total rigid">
									<strong>{{selectionCost | currency(true)}}</strong>
								</h1>
								<small v-if="selectionCost" class="gray-6 text-right">Plus tax</small>
							</div>
						</div>

						<!-- is free internal plan -->
						<div class="row centering flexible" v-else>
							<div class="column separated flexible">
								<h4 class="flexible">
									No upcoming charges
								</h4>
								<small class="gray-6 rigid">
									<!-- <span v-if="selection.isCurrent && !selection.active">Ends {{current && current.expiry | date}}</span>
									<span v-else-if="selection.isCurrent && selection.active || current">Renews {{current && current.expiry | date}}</span> -->
									<span v-if="selectionName === 'Basic'">Renews in 6 months</span>
									<span v-else>Renews in 1 year</span>
								</small>

							</div>
							<h1 class="total rigid">
								<strong>Free</strong>
							</h1>
						</div>

					</div>
				</div>
			</header>

			<scope-sub-placeholder v-if="!selectionId || subscriptionLoading" :plan-items="3" :package-items="4"></scope-sub-placeholder>

			<!-- paid plan options -->
			<div v-else-if="newPlan" class="row rigid separated-extra">
				<div class="change-summary">
					<!-- free trial flow -->
					<ul v-if="useTrial" class="column">
						<li class="rigid">
							<h2>You’ve chosen <em>{{newPlan.displayName}} free trial</em>.
							</h2>
						</li>
						<li class="rigid">
							<h2>What happens after my trial ends?</h2>
							<ul class="bullets">
								<li class="bullet">
									<div class="bullet-margin"><i class="fas fa-angle-double-right"></i></div>
									<div class="bullet-content">You will not be charged.</div>
								</li>
								<li class="bullet">
									<div class="bullet-margin"><i class="fas fa-angle-double-right"></i></div>
									<div class="bullet-content">If you have an existing subscription, it will resume automatically.
									</div>
								</li>
								<li class="bullet">
									<div class="bullet-margin"><i class="fas fa-angle-double-right"></i></div>
									<div class="bullet-content">If you'd like to subscribe to <em>{{newPlan.displayName}}</em>, you can purchase by credit card or purchase order. <a href="mailto:support@support.tekcloud.com">Contact support</a> for more information.
									</div>
								</li>
							</ul>
						</li>
					</ul>
					<!-- onboarding flow -->
					<ul v-else class="column">
						<li class="rigid">
							<h2>You’ve chosen <em>{{newPlan.displayName}}</em>.</h2>
						</li>
						<li class="rigid">
							<h2>What happens next?</h2>
							<ul class="bullets">
								<li class="bullet">
									<div class="bullet-margin"><i class="fas fa-angle-double-right"></i></div>
									<div v-if="newPlan.interval === 'every6months'" class="bullet-content">Your new plan will start now and renew every 6 months.</div>
									<div v-else class="bullet-content">Your new plan will start now and renew {{newPlan.interval}}.</div>
								</li>
								<li class="bullet">
									<div class="bullet-margin"><i class="fas fa-angle-double-right"></i></div>
									<div class="bullet-content">You can change your plan at anytime. See <a target="_blank" href="https://dev-www.tekcloud.com/terms">Terms of Use</a>.</div>
								</li>
							</ul>
						</li>
					</ul>
				</div>

				<!-- review plan -->
				<div v-if="newPlan" class="column flexible separated-extra plan-comparison">
					<section class="rigid row plan-cards">
						<label class="plan-card plan-card-primary review-change gap">
							<!-- <input type="radio" hidden :value="newPlan.id" @click="setSelection(newPlan)" :checked="selection.id === newPlan.id"/> -->
							<header class="row centering separated">
								<h2 class="plan-title gap rigid">{{newPlan.displayName}}</h2>
								<i class="fas fa-check-circle"></i>
							</header>
							<section v-if="newPlan.hasTrial" class="column billing-options flexible separated-extra">
								<label class="button flexible relative success" :class="{active: useTrial}">
									<input type="radio" hidden  v-model="useTrial" name="plan" :value="true" @click="onButtonClick">
									{{TRIAL_DAYS}}-day trial
								</label>
								<label class="button flexible relative" :class="{active: !useTrial}">
									<input type="radio" hidden  v-model="useTrial" name="plan" :value="false" @click="onButtonClick">
									<div v-if="!newPlan.amount">Free</div>
									<div v-else >{{newPlan.amount | currency(true)}} {{newPlan.displayInterval}}</div>
								</label>
							</section>
							<h3 v-else class="no-margin row separated">
								<span class="rigid">{{newPlan.amount | currency(true, true)}} <small >{{newPlan.displayInterval}}</small></span>
								<!-- <small v-if="plan.isTrial" class="rigid badge badge-hollow badge-success">Free for 30 Days</small> -->
							</h3>
						</label>
					</section>

					<footer class="column separated-extra" v-if="newPlan">
						<payment-notice
							class="below"
							v-if="paymentRequired"
							:on-click="onPaymentClick"
							:returnPath="'/subscriptions/scope'"
							:model="account.paymentMethod"
							:is-dirty="isDirty"
							:loading="!paymentMethodLoaded">
						</payment-notice>

						<estimated-cost :loading="loadingTaxInfo" v-if="selectionCost" :cost="estimatedCost"></estimated-cost>

						<div v-if="changeSubscriptionError" class="row rigid">
							<div v-if="changeSubscriptionError.type === 'NEEDS_REVIEW'" class="notice warning gap">
								<p>
									In compliance with U.S. Government regulation, Tektronix is required to review all software download activity. Our team has been notified and will contact you once your account has been cleared.
									This process may take up to two U.S. business days. We apologize for any inconvenience.
								</p>
								<p>
									If you have any questions, please <a href="mailto:export-control@support.tekcloud.com?subject=Account%20Under%20Review">contact us</a>.
								</p>
							</div>
							<div v-else class="notice error gap">
								<!-- <button type="button" class="close link" @click="removeNotices">×</button> -->
								<div v-if="changeSubscriptionError.type === 'StripeCardError'">
									{{changeSubscriptionError.message}}
								</div>
								<div v-else-if="changeSubscriptionError.type === 'PAYMENT_GATEWAY_ERROR'">
									There was an error processing your transaction.
								</div>
								<div v-else-if="changeSubscriptionError.message === 'Cannot extend maintenance for this duration.'">
									{{ changeSubscriptionError.message }}
								</div>
								<div v-else>
									There was an error creating your subscription.
								</div>
							</div>
						</div>

						<!-- </footer> -->
						<footer class="row flexible separated-extra right">
							<button @click="resetState" type="button" class="flexible">Cancel</button>
							<button :disabled="submitDisabled" type="submit" :class="{success: useTrial}" class="primary flexible">
								<span v-if="submitting"><i class="fas fa-spinner fa-spin"></i></span>
								<span v-else-if="useTrial">Start {{TRIAL_DAYS}}-Day Trial</span>
								<span v-else-if="selection.amount">Pay {{estimatedCost && estimatedCost.total}}</span>
								<span v-else>Subscribe</span>
							</button>
						</footer>
					</footer>
				</div>
				<!-- /review plan -->
			</div>
			<div v-else class="column gap separated-extra">
				<section class="rigid row plan-cards">
					<label class="plan-card plan-card-primary gap" v-for="(plan, index) in filterBasic(planCards)" v-bind:key="index" :class="{'selected':selection.tierName === plan.tierName}">
						<input type="radio" hidden :value="plan.id" @click="setTierSelection(plan)" :checked="selection.id === plan.id"/>
						<header class="row baseline separated">
							<span class="row baseline separated flexible">
								<h2 class="plan-title rigid">{{plan.tierName}}</h2>

								<span v-if="plan.isTierTrial" class="badge badge-mono badge-success rigid">Trial</span>
							</span>
							<i class="fas fa-check-circle"></i>
						</header>
						<h3 class="no-margin row separated centering space-between">
							<span class="rigid">{{plan.amount | currency(true, true)}} <small >{{plan.displayInterval}}</small></span>
							<span v-if="plan.hasTrial" class="rigid badge badge-success">Try Free</span>
						</h3>
					</label>
				</section>

				<section>
					<h3>Packages
						<small class="gray-6 no-margin" v-if="selection.isPro">(Choose 1 package)</small>
						<small class="gray-6 no-margin" v-else-if="selection.isUltimate">(All packages included)</small>
						<small class="gray-6 no-margin" v-else>(No packages included)</small>
					</h3>
					<div class="rigid row plan-cards flowing packages">
						<label class="plan-card gap" v-for="(proPackage, index) in proPackages" v-bind:key="index" :class="{'selected':selectedPackage === proPackage.id && selection.tierName === 'Professional' || selection.tierName === 'Ultimate', 'strikethrough': selection.tierName !== 'Professional' && selection.tierName !== 'Ultimate' }">
							<input type="radio" hidden :value="proPackage.id" @click="setPackageSelection(proPackage)" :disabled="selection.tierName !== 'Professional'" v-model="selectedPackage" :checked="selectedPackage === proPackage.id"/>
							<header class="row baseline separated">
								<span class="row baseline flexible">
									<h3 class="plan-title flexible row separated">
										<span class="flexible">{{proPackage.name}}</span>
									</h3>
									<span v-if="proPackage.isProTrial && proPackage.isTrial" class="badge badge-mono badge-success rigid">Trial</span>
								</span>
								<i class="fas rigid fa-check-circle"></i>
							</header>
							<div class="gray-6">{{proPackage.description}}</div>
						</label>
					</div>
				</section>

				<section class="column">
					<header class="row separated baseline popover-target-wrapper ">
						<h3 class="flexible">Features</h3>
						<span class="row rigid">
							<a class="rigid" target="_blank" :href="scopePrereqUrl">
								View Prerequisites&nbsp;
							</a>
							<popover
								class="right rigid half"
								:message="'Each plan includes Programmable Interface functionality, which is installed separately. Click View Prerequisites for a list of install instructions.'">
								<i slot="popover-target" class="fas fa-info-circle mouseover"></i>
							</popover>
						</span>
					</header>
					<ul class="plan-features row separated-extra">
						<div class="column flexible">
							<li v-for="(feature, index) in selection.featureList1" v-bind:key="index" class="bullet" :class="{'strikethrough': feature.notSupported}">
								<div class="bullet-margin"><i class="fas fa-check"></i></div>
								<div class="bullet-content column">{{feature.description}}
									<small class="links popover-target-wrapper" v-if="(!feature.notSupported) && feature.requiresPrereq">
										<a target="_blank" :href="scopePrereqUrl">Install Instructions</a>
										<popover
											class="left rigid"
											:message="'This feature requires prerequisite software. See Install Instructions for more information.'">
											<i slot="popover-target" class="fas fa-info-circle mouseover"></i>
										</popover>
									</small>
								</div>
							</li>
						</div>
						<div class="column flexible">
							<li v-for="(feature, index) in selection.featureList2" v-bind:key="index" class="bullet" :class="{'strikethrough': feature.notSupported}">
								<div class="bullet-margin"><i class="fas fa-check"></i></div>
								<div class="bullet-content column">{{feature.description}}
									<small class="links popover-target-wrapper" v-if="!feature.notSupported && feature.requiresPrereq">
										<a target="_blank" :href="scopePrereqUrl">Install Instructions</a>
										<popover
											class="left rigid"
											:message="'This feature requires prerequisite software. See Install Instructions for more information.'">
											<i slot="popover-target" class="fas fa-info-circle mouseover"></i>
										</popover>
									</small>
								</div>
							</li>
						</div>
					</ul>
				</section>

				<footer class="choose-plan row rigid separated-extra rigid">
					<button class="rigid primary" type="button" @click="reviewSelection(selection)">Choose plan</button>
				</footer>

			</div>
		</div>

	</form>
</template>

<script>
import capitalize from '../filters/capitalize';
import currency from '../filters/currency';
import byte from '../filters/byte';
import date from '../filters/date';
import { scrollTo } from '../directives/scroll-to';
import PaymentNotice from '../components/PaymentNotice';
import Popover from '../components/Popover';
import ToggleSwitch from '@/components/ToggleSwitch';
import Spinner from '../components/Spinner';
import taxUtil from '@/modules/tax-util';
import EstimatedCost from '@/components/EstimatedCost';
import ScopeSubPlaceholder from '../components/ScopeSubPlaceholder';
import H1Placeholder from '../components/H1Placeholder';
import H2Placeholder from '../components/H2Placeholder';
import TablePlaceholder from '../components/TablePlaceholder';
import TrialBadge from '@/components/TrialBadge';
import Actions from '../components/Actions';
import { mapGetters, mapState, mapActions } from 'vuex';
import accountService from '@/modules/account-service';
import Vue from 'vue';
import ENV_VARS from '@/modules/env-vars.js';

export default {
	name: 'ScopeSubEdit',
	filters: {
		currency,
		date,
		capitalize,
		byte
	},
	directives: {
		scrollTo
	},
	components: {
		PaymentNotice,
		Spinner,
		ScopeSubPlaceholder,
		H1Placeholder,
		H2Placeholder,
		TablePlaceholder,
		Popover,
		TrialBadge,
		ToggleSwitch,
		EstimatedCost
	},
	data() {
		return {
			touched: false,
			previousIntervalId: null,
			submitting: false,
			selectedId: null,
			// plans: [],
			subscriptionLoading: false,
			getSubscriptionError: null,
			changeSubscriptionError: null,
			showConfirmation: false,
			TRIAL_DAYS: ENV_VARS.TRIAL_DAYS
		};
	},
	computed: {
		...mapGetters({
			account: 'account',
			address: 'address',
			accountStatus: 'accountStatus',
			isUserLoaded: 'isUserLoaded',
			scopeAppUrl: 'auth/scopeAppUrl',
			scopePrereqUrl: 'auth/scopePrereqUrl',
			scopeConfirmationUrl: 'auth/scopeConfirmationUrl',
			installTekScopeUrl: 'auth/installTekScopeUrl',
			scopeAddressUrl: 'auth/scopeAddressUrl',
			updateLicenseUrl: 'auth/updateLicenseUrl'
		}),
		...mapState('scope', {
			intervalOptions: 'intervalOptions',
			selection: 'selection',
			subRenews: 'subscriptionRenews',
			planCards: 'planCards',
			plans: 'plans',
			proPackages: 'proPackages',
			plansMap: 'plansMap',
			newPlan: 'newPlan'
		}),
		useTrial: {
			get() {
				return this.$store.state.scope.useTrial;
			},
			set(value) {
				this.$store.dispatch('scope/SET_TRIAL_FLAG', value);
			},
		},
		selectedPackage: {
			get() {
				return this.$store.state.scope.selectedPackage;
			},
			set(value) {
				this.$store.dispatch('scope/SET_PACKAGE', value);
			},
		},
		...mapState('subscription', {
			changeSubscriptionStatus: 'changeSubscriptionStatus',
			redirectToScope: 'redirectToScope'
		}),
		...mapState('auth', [
			'refreshToken'
		]),
		...mapState({
			estimatedTax(state) {
				return state.account.estimatedTax;
			},
			loadingTaxInfo(state) {
				return state.account.loadingTaxInfo;
			},
		}),
		estimatedCost() {
			// wait for a new non-trial/free plan and estimatedTax before calculating
			return this.newPlan && this.selectionCost && this.estimatedTax ? taxUtil.calculateTax(this.newPlan.amount, this.estimatedTax.taxRatePercentage) : null;
		},
		paymentRequired(){
			return this.newPlan && this.newPlan.paymentMethodRequired && !this.useTrial;
		},
		newUser(){
			return this.$route.query.r && this.$route.query.r === 'newuser';
		},
		showOnboardingFlow() {
			return this.redirectToScope || this.subscriptionLoading;
		},
		selectionId(){
			return this.selection && this.selection.id;
		},
		preselectedPlanId(){
			return this.$route.query.package;
		},
		selectionName(){
			return this.selection && this.selection.name;
		},
		newPlanId(){
			return this.newPlan && this.newPlan.tierName === "Professional" ? this.plansMap[this.selectedPackage].id : this.newPlan.id;
		},
		selectionCost() {
			let selection = this.selection;

			if (!selection || !selection.amount || this.useTrial) {
				return 0;
			}
			return selection.amount;
		},
		isDirty() {
			return this.selectionSelected && this.touched;
		},
		scopePlansUrl() {
			return ENV_VARS.DRIVE_PUBLIC_URL + '#pricing';
		},
		isYearly() {
			return this.selection.interval === 'yearly';
		},
		newTrial() {
			return this.selection && this.selection.hasTrial && this.useTrial;
		},
		submitDisabled() {
			return this.processing || (this.paymentRequired && !this.account.paymentMethod);
		},
		processing() {
			return this.subscriptionLoading || this.changeSubscriptionStatus.loading || this.submitting;
		},
		showPlanLoader() {
			return this.subscriptionLoading && this.plans.length === 0;
		},
		paymentMethodLoaded() {
			return this.account.paymentMethod !== undefined;
		},
		redirectReason() {
			return this.$route.query && this.$route.query.r;
		},
		credit() {
			return this.account.balanceCents;
		}
	},
	methods: {
		...mapActions('subscription', {
			clearStoredSelection: 'CLEAR_SELECTION',
		}),
		reviewSelection(plan) {
			this.$store.dispatch('scope/SET_NEW_PLAN', plan);
		},
		setPackageSelection(proPackage) {
			const selectedPackage = proPackage.id;

			this.selectedPackage = selectedPackage;
			this.$store.dispatch('scope/SET_SELECTION', { selection: proPackage });//, selectedPackage });
		},
		setTierSelection(selectedPlan){
			if (!selectedPlan) {
				return;
			}
			let selectedPackage = this.selectedPackage;

			// find package to select when professional tier is chosen
			if (selectedPlan.isPro && !selectedPackage) {
				selectedPackage = selectedPlan.id;
			}
			// if pro set correct package
			if (selectedPlan.isPro) {
				selectedPlan = this.plansMap[selectedPackage];
			}
			// if no new plan is selected, fall back to plans trial flag
			if (!this.newPlan) {
				this.useTrial = selectedPlan.hasTrial;
			}

			this.selectedPackage = selectedPackage;
			this.$store.dispatch('scope/SET_SELECTION', { selection: selectedPlan });//, selectedPackage });
		},
		filterBasic(planCards) {
			// filter out basic plan once you've subbed to it
			return planCards.filter(plan => !plan.isAtSubCountLimit);
		},
		onPaymentClick(){
			return null;
		},
		deepCopy(obj) {
			return JSON.parse(JSON.stringify(obj));
		},
		clearRouteParams(){
			this.$router.replace({query: null});
		},
		getPlanByIntervalId(intervalId) {
			return this.deepCopy(this.plans).find(plan => {
				return plan.intervalId === intervalId;
			});
		},
		getPlanById(id) {
			return this.deepCopy(this.plans).find(plan => {
				return plan.id === id;
			});
		},
		getInterval(plan) {
			return (!plan.interval || plan.interval === 'free') ? 'monthly' : plan.interval;
		},
		onButtonClick() {
			this.touched = true;
			this.removeNotices();
		},
		onRenewalChange(val) {
			const vm = this;
			this.$store.dispatch('scope/SET_RENEWAL_FLAG', val);
		},
		createSubscription() {
			this.submitting = true;

			const subObj = {
				cancelAtPeriodEnd: this.subRenews,
				interval: this.selection.interval,
				id: this.newPlanId,
				trial: this.useTrial
			};

			this.$store.dispatch('scope/ADD_SUBSCRIPTION_REQUEST', subObj).then((sub) => {
				this.touched = false;
				// part of registration flow > send back to download tekscope
				if (this.redirectToScope) {
					window.location.href = this.scopeConfirmationUrl;
					return;
				}
				// send to add param to license screen
				window.location.href = this.installTekScopeUrl + `&r=add&subid=${sub.id}`;
			}).catch((error) => {
				this.submitting = false;
				if (error.type === 'MISSING_ADDRESS') {
					window.location.href = this.scopeAddressUrl;
				}
				this.changeSubscriptionError = error;
			});
		},
		leavePlan() {
			this.resetState();
			this.$store.dispatch('scope/TEAR_DOWN');
			this.$router.push('/');
		},
		resetState() {
			this.$store.dispatch('scope/RESET_STATE');
			this.changeSubscriptionError = null;
			this.useTrial = this.selection.hasTrial;
			if (Object.entries(this.$route.query).length) {
				this.clearRouteParams();
			}
		},
		resetCouponState() {
			this.couponDetails = null;
			this.couponDetailsError = null;
			this.couponCodeModel = null;
		},
		restoreSubscriptionState() {
			// load initial plan options
			this.$store.dispatch('subscription/RESET_PLANS_STATE');
			this.resetCouponState();
		},
		selectPreselectedPlan() {
			const preselectedPlan = this.plansMap[this.preselectedPlanId];

			if (preselectedPlan) {
				this.setTierSelection(preselectedPlan);
				this.clearRouteParams();
			}
		},
		removeNotices() {
			// remove notices to clean up view
			this.$store.dispatch('subscription/RESET_CHANGE_SUBSCRIPTION_STATUS');
			this.showRemoveNotice = false;
		}
	},
	created() {
		let vm = this;
		vm.subscriptionLoading = true;
		vm.$store.dispatch('scope/GET_PLANS_REQUEST',  { subId: vm.$route.params.subId })
			.then((initialPlan)=>{
				vm.subscriptionLoading = false;

				if (this.preselectedPlanId) {
					this.selectPreselectedPlan();
					return;
				}

				// selection already exists, return out
				if (vm.selectionId) {
					return;
				}

				// if restoring, initialPlan is null
				if (initialPlan) {
					vm.setTierSelection(initialPlan);
				}

			})
			.catch(error => {
				vm.subscriptionLoading = false;
				vm.getSubscriptionError = error;
				console.error(error);
			});
		if (!vm.redirectToScope) {
			vm.$store.dispatch('subscription/SET_SCOPE_REDIRECT', !!vm.newUser);
		}
	}
};
</script>



// WEBPACK FOOTER //
// ./src/views/ScopeSubCreate.vue